<!-- Loading bar -->
<devstroupe-loading-bar></devstroupe-loading-bar>

<!-- Navigation -->
<devstroupe-vertical-navigation
    class="print:hidden"
    [ngClass]="config.class"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigationData"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container devstroupeVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex justify-center items-center p-6">
            <!-- Light version -->
            <img class="dark:hidden" [src]="config.logo" alt="Logo image" class="w-24" />
        </div>
    </ng-container>
    <!-- Navigation body hook -->
    <ng-container devstroupeVerticalNavigationContentBody>
        <company-selector> </company-selector>
    </ng-container>

    <ng-container devstroupeVerticalNavigationFooter>
        <div class="relative flex flex-0 items-center justify-center w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
            <span class="font-medium text-primary-900">ARTSYS &copy; 2025</span>
            <!-- version_app -->
            <span class="text-sm text-secondary ml-2" *ngIf="version_app">v{{ version_app }}</span>
        </div>
    </ng-container>
</devstroupe-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full sm:h-16 px-2 z-49 bg-default dark:bg-transparent print:hidden">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="flex sm:items-center content-center pr-2 justify-center xl:justify-between xs:flex-wrap gap-2 p-2 sm:p-0">
            <h1 *ngIf="!!pageTitle" class="text-2xl text-primary font-semibold w-full md:w-auto sm:ml-2 xl:mr-20">{{ pageTitle }}</h1>
            <mat-form-field class="devstroupe-mat-dense min-w-60 search-input" [subscriptSizing]="'dynamic'" *ngIf="!ignoreSearch">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                <input matInput [formControl]="searchInputControl" [autocomplete]="'off'" [placeholder]="'O que você procura?'" />
                <!-- <input matInput [formControl]="searchInputControl" [autocomplete]="'off'" [placeholder]="'Pesquisar...'"> -->
            </mat-form-field>
        </div>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <devstroupe-fullscreen class="hidden md:block"></devstroupe-fullscreen> -->
            <div class="uppercase font-semibold flex text-gray-700 dark:text-secondary-500 ml-2">
                <button mat-icon-button [matTooltip]="isDark ? 'Claro' : 'Escuro'" (click)="setTheme(isDark ? 'light' : 'dark')">
                    <mat-icon [svgIcon]="isDark ? 'heroicons_outline:sun' : 'heroicons_outline:moon'"></mat-icon>
                </button>
                <button mat-icon-button [matTooltip]="isAuto ? 'Auto Ligado' : 'Auto Desligado'" (click)="setThemeAuto()">
                    <mat-icon [svgIcon]="isAuto ? 'heroicons_solid:bolt' : 'heroicons_outline:bolt'"></mat-icon>
                </button>
            </div>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-center w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">artsys &copy; desde 06/2024 </span>
    </div> -->
</div>
